import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable, shareReplay} from "rxjs";
import {ExportConfigDto} from "../../../../models/config/export/ExportConfigDto";
import {AntragConfigDto} from "../../../../models/config/antrag/AntragConfigDto";
import {FeaturesConfig} from "./features-config.model";
import {EigenanteilConfig} from "./eigenanteil-config.model";
import {HttpHeaderService} from "../../../utils/http/http-header.service";
import {UrlConfigDto} from "../../../../models/config/url/UrlConfigDto";

@Injectable({
  providedIn: 'root'
})
export class GeneralConfigService {

  baseUrl = 'api/config/general';

  private featuresConfig$: Observable<FeaturesConfig> | null = null;
  private eigenanteilConfig$: Observable<EigenanteilConfig> | null = null;

  constructor(
    private readonly http: HttpClient,
    private readonly headerService: HttpHeaderService
  ) {}

  getExportConfig(): Observable<ExportConfigDto> {
    return this.http.get<ExportConfigDto>(this.baseUrl + "/export", { headers: this.headerService.getAuthHeaderApplicationJson() });
  }

  getAntragConfig(): Observable<AntragConfigDto>{
    return this.http.get<AntragConfigDto>(this.baseUrl + "/antrag", { headers: this.headerService.getAuthHeaderApplicationJson() });
  }

  getUrlConfig(): Observable<UrlConfigDto>{
    return this.http.get<UrlConfigDto>(this.baseUrl + "/url", { headers: this.headerService.getAuthHeaderApplicationJson() });
  }

  getFeaturesConfig(): Observable<FeaturesConfig> {
    if (!this.featuresConfig$) {
      this.featuresConfig$ = this.http.get<FeaturesConfig>(this.baseUrl + "/features", { headers: this.headerService.getAuthHeaderApplicationJson() }).pipe(
        shareReplay(1)
      );
    }
    return this.featuresConfig$;
  }

  getEigenanteilConfig(): Observable<EigenanteilConfig> {
    if (!this.eigenanteilConfig$) {
      this.eigenanteilConfig$ = this.http.get<EigenanteilConfig>(this.baseUrl + "/eigenanteil", { headers: this.headerService.getAuthHeaderApplicationJson() }).pipe(
        shareReplay(1)
      );
    }
    return this.eigenanteilConfig$;
  }
}
